import React, { FunctionComponent, useState } from "react"
import { Grid, Card as MaterialCard, Button, TextField, useTheme, Box } from "@mui/material"
import AddIcon from "@mui/icons-material/Add"
import { useTranslation } from "react-i18next"
import { useQuery } from "@apollo/client"
import {
  GETDISPOSALMERCHANTS_QUERY,
  DisposalMerchantsResult,
} from "../../../../api/graphql/queries/get-disposal-merchants"
import { DisposalMerchantItem } from "./disposal-merchant-item"

import { useSelectedDisposalMerchant } from "../../../../context/selected-disposal-merchant-context"
import { useRefetch } from "../../../../context/refetch-context"
import { ContentContainer } from "../../../partials/layout/content/content-container"

interface IDisposalMerchantSelectorProps {}

export const DisposalMerchantSelector: FunctionComponent<IDisposalMerchantSelectorProps> = (props) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const [disposalMerchantName, setDisposalMerchantName] = useState<string>("")
  const { setSelectedDisposalMerchantId } = useSelectedDisposalMerchant()

  const { needToRefetch, setNeedToRefetch } = useRefetch()

  const { data } = useQuery<DisposalMerchantsResult>(GETDISPOSALMERCHANTS_QUERY, {
    fetchPolicy: needToRefetch ? "network-only" : "cache-first",
    onCompleted: () => setNeedToRefetch(false),
  })

  const onFilterApplyClicked = () => {}

  const onFilterRemoveClicked = () => {}

  const onAddNewDisposalMerchantClicked = () => {
    setSelectedDisposalMerchantId(undefined)
  }

  return (
    <ContentContainer sx={{ height: `calc(100% - ${theme.spacing(2)})`, display: "flex", flexDirection: "column" }}>
      <Grid sx={{ p: 0, mb: 2, flex: "0 0 auto" }}>
        <Grid item>
          <Button
            type="button"
            variant="outlined"
            sx={{
              borderWidth: 0.5,
              borderRadius: 1,
              borderColor: theme.palette.primary.main,
              m: `${theme.spacing(1)} 0 ${theme.spacing(1)} 0`,
            }}
            onClick={onAddNewDisposalMerchantClicked}
            fullWidth
          >
            <AddIcon color="primary" />
          </Button>
        </Grid>
        <Grid item>
          <MaterialCard sx={{ p: 2, width: 270 }}>
            <Grid container direction={"column"} sx={{ width: 270 }} spacing={1}>
              <Grid item>
                <TextField
                  size="small"
                  id="outlined-search"
                  label={t("disposal_merchant_overview.filter.disposal_merchant_name")}
                  type="search"
                  variant="outlined"
                  placeholder="Saubermacher"
                  value={disposalMerchantName}
                  onChange={(ev) => {
                    setDisposalMerchantName(ev.target.value)
                  }}
                  fullWidth
                />
              </Grid>

              <Grid item>
                <Button variant="contained" type="button" color="primary" onClick={onFilterApplyClicked} fullWidth>
                  {t("collection_points.filter.apply_filter")}
                </Button>
              </Grid>
              <Grid item>
                <Button variant="contained" type="button" color="inherit" onClick={onFilterRemoveClicked} fullWidth>
                  {t("collection_points.filter.remove_filter")}
                </Button>
              </Grid>
            </Grid>
          </MaterialCard>
        </Grid>
      </Grid>
      {data && (
        <Box
          sx={{
            p: 0,
            flex: "1 1 auto",
            overflowY: "auto",
          }}
        >
          {data.getDisposalMerchants.map((disposalMerchant, index) => (
            <DisposalMerchantItem key={index} item={disposalMerchant} />
          ))}
        </Box>
      )}
    </ContentContainer>
  )
}
